import type { ReactNode } from "react";

import { useCurrentUser } from "@/hooks/use-current-user";
import type { PermissionRequirement } from "@/lib/permissions";

interface CanProps {
  permissions: PermissionRequirement;
  fallback?: ReactNode;
  children: ReactNode;
}

/** Renders children only when the current user has one of the required roles. */
export function Can({ permissions, fallback = null, children }: CanProps) {
  const { can } = useCurrentUser();
  return can(permissions) ? children : fallback;
}
